import React, { lazy } from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const tomos = [{
    name: 'Pilates Foundation',
    desc: 'La base sólida para principiantes.'
  }, {
    name: 'Core Intense',
    desc: 'Desafío de centro y estabilidad.'
  }, {
    name: 'Flow & Flex',
    desc: 'Transiciones líquidas y movilidad.'
  }, {
    name: 'Power Reformer',
    desc: 'Secuencias de fuerza y control.'
  }, {
    name: 'Mat Props',
    desc: 'Uso estratégico de accesorios (bandas, pelotas, aros).'
  }, {
    name: 'Clinical Care',
    desc: 'Adaptaciones seguras para patologías comunes.'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-193">
      <div className="max-w-5xl mx-auto" data-id="element-194">
        <div className="text-center mb-12" data-id="element-195">
          <div className="bg-pilates-lavender/25 text-pilates-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-196">
            LA SOLUCIÓN QUE ESPERABAS — UN SISTEMA 6 EN 1
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-197">
            6 libros en 1, diseñados para los{' '}
            <span className="italic text-pilates-sage-dark" data-id="element-198">
              profesionales del movimiento
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-199">
          <div data-id="element-200">
            <img src="https://cdn.magicpatterns.com/uploads/8rz6TJLsPTM4hKHjFXx9Q7/hf_20260601_184719_6f529274-a36a-40a0-b418-2da9c381932e.webp" alt="Cofre Kit Pilates Listo 6 libros en 1" className="w-full rounded-2xl shadow-xl" loading="lazy" decoding="async" width="800" height="800" data-id="element-201" />
          </div>

          <div data-id="element-202">
            <p className="text-pilates-slate text-base leading-relaxed mb-6" data-id="element-203">
              <span className="font-bold text-pilates-dark" data-id="element-204">
                KIT PILATES LISTO
              </span>{' '}
              es mucho más que un simple manual. Es un sistema operativo
              completo que te entrega 60 sesiones maestras, estructuradas
              pedagógicamente para garantizar fluidez y autoridad en el estudio.
            </p>

            <ul className="space-y-4 mt-8" data-id="element-205">
              {tomos.map((tomo, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-206">
                  <div className="mt-0.5 bg-pilates-sage/20 p-1 rounded-full text-pilates-sage-dark flex-shrink-0" data-id="element-207">
                    <Check className="w-4 h-4" data-id="element-208" />
                  </div>
                  <div data-id="element-209">
                    <span className="font-bold text-pilates-dark" data-id="element-210">
                      {tomo.name}
                    </span>{' '}
                    <span className="text-pilates-slate" data-id="element-211">— {tomo.desc}</span>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}